import {z} from "zod/v4-mini"
import "zod/v4"
import {shortStringify} from "@cm/utils"

export const ensureValidResult = <Returns>(graph: {returnsSchema: z.ZodMiniType}, value: Returns) => {
    const schema = graph.returnsSchema
    const result = schema.safeParse(value)
    if (!result.success) {
        throw new Error(`Invalid returned value for node ${graph.constructor.name}: ${shortStringify(value)}, ${z.prettifyError(result.error)}`, {
            cause: {value, issues: result.error.issues, schema},
        })
    } else {
        return result.data as Returns
    }
}
